import React from 'react';
import { Container, Link as MuiLink, Stack, Typography } from '@mui/material';
import { Link as RouteLink } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import registry from '../modules/registry';

// The live quiz lives in modules/quizapp/ but App.js routes it (see registry.js
// for why), so it isn't a registry entry and gets its card listed here.
const liveQuiz = {
    id: 'live-quiz',
    title: 'Live Quiz',
    blurb: 'A real-time classroom quiz — students join by scanning a QR code, answers stream back to the host over SSE.',
    href: '/live/host',
    cta: 'Host a Live Quiz',
    newTab: true,
};

const ProjectRow = ({ title, blurb, href, cta, newTab }) => {
    const linkProps = newTab
        ? { component: 'a', href, target: '_blank', rel: 'noopener noreferrer' }
        : { component: RouteLink, to: href };

    return (
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 0.5, sm: 2 }} alignItems={{ sm: 'baseline' }}>
            <Typography component="span" sx={{ fontWeight: 700, flexShrink: 0 }}>
                {title}
            </Typography>
            <Typography component="span" color="text.secondary" sx={{ flexGrow: 1 }}>
                {blurb}
            </Typography>
            <MuiLink {...linkProps} sx={{ flexShrink: 0, fontWeight: 600, whiteSpace: 'nowrap' }}>
                {cta} →
            </MuiLink>
        </Stack>
    );
};

const Projects = () => (
    <Container maxWidth="md" sx={{ pt: 8, pb: 12 }}>
        <PageHeader
            eyebrow="LIVE DEMOS"
            title={<>Things I've<br />built.</>}
            intro="Each of these is a self-contained project running on this site — open one and use it."
            sx={{ mb: 6 }}
        />

        <Stack spacing={3} divider={<Stack sx={{ borderTop: '1px solid', borderColor: 'divider' }} />}>
            {[...registry, liveQuiz].map((project) => (
                <ProjectRow key={project.id} {...project} />
            ))}
        </Stack>
    </Container>
);

export default Projects;
